// extracted by css-extract-rspack-plugin
var _1 = "v5RwQTTBhMW5oHOI";
export { _1 as "kbd" }
// extracted by css-extract-rspack-plugin
var _1 = "v5RwQTTBhMW5oHOI";
export { _1 as "kbd" }
